import reactStringReplace from "react-string-replace";
import { UnsupportedValueInCurlyBraces, ValueInCurlyBraces } from "src/components/common/value/value-in-curly-braces";
import { FeedCardLink } from "src/components/feed-card/content-blocks/link/feed-card-link";
import { FeedCardNumber } from "src/components/feed-card/content-blocks/number/feed-card-number";
import { FeedCardPrice } from "src/components/feed-card/content-blocks/price/feed-card-price";
import { FeedCardText } from "src/components/feed-card/content-blocks/text/feed-card-text";
import { TFeedCardSmartParagraphContentBlock } from "src/components/feed-card/types/content";
import { EnumFeedCardBlockType } from "src/components/feed-card/types/enums";
import { WORD_IN_CURLY_BRACES_REGEX } from "src/consts/rexeges";

export interface IFeedCardParsedTextProps {
    text: string;
    args: { [key: string]: TFeedCardSmartParagraphContentBlock };
    allowedContentBlocks: ReadonlyArray<TFeedCardSmartParagraphContentBlock["type"]>;
    onLinkClick?: (url: string) => void;
}

export const FeedCardParsedText = ({ text, args, allowedContentBlocks, onLinkClick }: IFeedCardParsedTextProps) => (
    <>
        {reactStringReplace(text, WORD_IN_CURLY_BRACES_REGEX, (key, index) => {
            if (!args.hasOwnProperty(key)) {
                return <ValueInCurlyBraces key={index} value={key} />;
            }

            const contentBlock = args[key];
            if (!allowedContentBlocks.includes(contentBlock.type)) {
                return <ValueInCurlyBraces key={index} value={contentBlock.type} />;
            }

            return <ContentBlock key={index} onLinkClick={onLinkClick} {...contentBlock} />;
        })}
    </>
);

type TParsedPartProps = TFeedCardSmartParagraphContentBlock & {
    onLinkClick?: (url: string) => void;
};

const ContentBlock = ({ type, body, onLinkClick }: TParsedPartProps) => {
    switch (type) {
        case EnumFeedCardBlockType.Link:
            return <FeedCardLink {...body} onClick={onLinkClick} />;
        case EnumFeedCardBlockType.Number:
            return <FeedCardNumber {...body} />;
        case EnumFeedCardBlockType.Price:
            return <FeedCardPrice {...body} />;
        case EnumFeedCardBlockType.Text:
            return <FeedCardText as="span" value={body} />;
        default:
            return <UnsupportedValueInCurlyBraces value={type} />;
    }
};
